import { Reducer } from "redux";

import defaultState from "../default-state";

// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.

export const availabilities: Reducer<Readonly<AvailabilityAllotments> | null>
	= (state = defaultState.availabilities, incomingAction: IAction) => {
		switch (incomingAction.type) {
			case "ALLOTMENT_LOAD_AVAILABILITIES":
				const loadAction = incomingAction as IAllotmentLoadAvailabilitiesAction;
				if(state === null){
					return {
						[loadAction.supplierId]: loadAction.allotment,
					};
				}
				return {
					...state,
					[loadAction.supplierId]: loadAction.allotment,
				};
			case "ALLOTMENT_CLEAR_STORE":
				return null;
			default:
				return state;
		}
	};



// WEBPACK FOOTER //
// ./src/store/allotments/availabilities-reducer.ts